import React from "react";
import { Form, Input, Icon, Button } from "antd";
import { Toggle } from "react-powerplug";

const UserForm = Form.create()(
  class extends React.Component {
    state = {};

    handleSubmit = (e) => {
      const { form, onSubmit } = this.props;

      e.preventDefault();
      form.validateFields(async (err, values) => {
        if (err) {
          return;
        }
        await onSubmit(values);
      });
    };

    render() {
      const {
        loading,
        form: { getFieldDecorator },
      } = this.props;

      return (
        <Form onSubmit={this.handleSubmit} autoComplete="off" layout="vertical">
          <Toggle initial={false}>
            {({ on, toggle }) => (
              <Form.Item label="New password">
                {getFieldDecorator("password", {
                  rules: [{ required: true, message: "Password is required" }],
                  validateTrigger: ["onBlur"],
                })(
                  <Input
                    type={on ? "text" : "password"}
                    placeholder="Please enter a password"
                    prefix={<Icon type="lock" />}
                    suffix={
                      <Icon
                        type={on ? "eye" : "eye-invisible"}
                        onClick={toggle}
                      />
                    }
                  />
                )}
              </Form.Item>
            )}
          </Toggle>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              Save
            </Button>
          </Form.Item>
        </Form>
      );
    }
  }
);

export default UserForm;
